{
  "service-selection-dialog": {
    "buttons": {
      "save": "Save"
    },
    "text": {
      "service-selection": "Service selection"
    }
  },
  "service-selection-form": {
    "buttons": {
      "add-more": "Add more service"
    },
    "text": {
      "duration": "Duration",
      "hint": "Please select at least one service",
      "total": "Total"
    }
  }
}
